import { render, staticRenderFns } from "./SelectShareFolderDialogue.vue?vue&type=template&id=8d921a6c&scoped=true"
import script from "./SelectShareFolderDialogue.vue?vue&type=script&lang=js"
export * from "./SelectShareFolderDialogue.vue?vue&type=script&lang=js"
import style0 from "./SelectShareFolderDialogue.vue?vue&type=style&index=0&id=8d921a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d921a6c",
  null
  
)

export default component.exports